import { QuestionStudyActivitySubType } from '@mildang/graphql-artifact';

export const workbookActivities: QuestionStudyActivitySubType | `${QuestionStudyActivitySubType}`[] = [
  'SELECTING_GRAMMAR_OR_VOCABULARY',
  'FILLING_BLANK_TYPING',
  'FINDING_REFERRAL_TARGET',
  'FILLING_BLANK_CHOICE',
];

export const workbookActivityNodeNames: Record<
  QuestionStudyActivitySubType | 'FILLING_BLANK_TYPING_V2',
  string
> = {
  ['SELECTING_GRAMMAR_OR_VOCABULARY']: 'selectionQuiz',
  ['FILLING_BLANK_TYPING']: 'blankQuiz',
  ['FILLING_BLANK_TYPING_V2']: 'blankQuizV2',
  ['FINDING_REFERRAL_TARGET']: 'targetingQuiz',
  ['FILLING_BLANK_CHOICE']: 'matchingQuiz',
  ['COMMON']: '',
  ['CHART']: '',
  ['GRAPH']: '',
};
